// extracted by mini-css-extract-plugin
module.exports = {"wrap":"errorPage_wrap__i6Eu_","try_btn":"errorPage_try_btn__wrn2I"};